import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { FButton } from "@/components/forkd/FButton";
import { FInput } from "@/components/forkd/FInput";
import { Wordmark } from "@/components/forkd/Wordmark";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    setLoading(false);
    if (error) {
      setErr(error.message);
      return;
    }
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-[var(--colour-background)] px-5 pt-16 pb-10 flex flex-col">
      <div className="flex justify-center mb-10">
        <Wordmark size={40} />
      </div>
      <h2 className="text-[20px] font-semibold text-center mb-2">Reset your password</h2>
      <p className="text-center text-[14px] text-[var(--colour-text-secondary)] mb-6">
        We'll email you a reset link.
      </p>

      {sent ? (
        <div className="bg-[var(--colour-surface)] rounded-[var(--radius-md)] p-5 text-center border border-[var(--colour-border)]">
          <p className="text-[15px]">
            If an account exists for <strong>{email}</strong>, a reset link is on its way.
          </p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-3">
          <FInput
            name="email"
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            error={err}
          />
          <FButton type="submit" fullWidth loading={loading}>
            Send reset link
          </FButton>
        </form>
      )}

      <p className="mt-auto pt-8 text-center text-[14px]">
        <Link to="/signin" className="text-[var(--colour-accent)] font-semibold">
          Back to sign in
        </Link>
      </p>
    </div>
  );
}
